var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h3',{staticClass:"title"},[_vm._v("Wybierz urządzenie")]),_vm._v(" "),_vm._l((_vm.EquipmentTypeList[_vm.userData.EquipmentType]),function(eq,i){return _c('div',{key:i,staticClass:"btn-group"},[_c('button',{staticClass:"btn full",style:({ background: _vm.$color }),attrs:{"type":"button"},on:{"click":function($event){return _vm.btnHandler(eq.k)}}},[_vm._v(_vm._s(eq.v))])])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b9e5075e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/assistance_steps/StepHomeRepairVendor.vue
// module id = 233
// module chunks = 0